// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".charts-sdk-select .vs__deselect[data-v-01dffb61]{fill:#e5e5e5;margin-left:5px}.charts-sdk-select .vs__selected[data-v-01dffb61]{color:#fff!important;background-color:#1b3d5e!important}.dark-layout .custom-datetime-icon input[type=datetime-local][data-v-01dffb61]::-webkit-calendar-picker-indicator{filter:invert(100%)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
